import React, { useEffect, useState } from "react";
import api from "../../api/api";
import "../../css/Meeting.css";

const Meeting = () => {
  const [username, setUsername] = useState("");
  const [dropdownValue, setDropdownValue] = useState("");
  const [textInput, setTextInput] = useState("");
  const [location, setLocation] = useState("");
  const [meetingData, setMeetingData] = useState({});
  const [uploadedImage, setUploadedImage] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [meetingsList, setMeetingsList] = useState([]);
  const [zoomImageUrl, setZoomImageUrl] = useState(null);

  const [apiKey, setApiKey] = useState("");

  const roles = ["Dealer", "Farmer"];

  // Dealer form fields
  const [dealerName, setDealerName] = useState("");
  const [firmName, setFirmName] = useState("");
  const [brands, setBrands] = useState([""]);

  const [sale, setSale] = useState("");

  // Farmer form fields
  const [farmerName, setFarmerName] = useState("");
  const [dob, setDob] = useState("");
  const [anniversaryDate, setAnniversaryDate] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [record, setRecord] = useState("");
  const [cattleBuff, setCattleBuff] = useState("");
  const [cattleCow, setCattleCow] = useState("");
  const [cattleCalf, setCattleCalf] = useState("");
  const [trailBag, setTrailBag] = useState("");
  const [schedule, setSchedule] = useState("");
  const [meetingNote, setMeetingNote] = useState("");
  const [bags, setBags] = useState("");

  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState("");

  const handleBrandChange = (index, value) => {
    const updatedBrands = [...brands];
    updatedBrands[index] = value;
    setBrands(updatedBrands);
  };

  const addBrandField = () => {
    if (brands.length < 4) {
      setBrands([...brands, ""]);
    }
  };

  const deleteBrandField = (index) => {
    const updatedBrands = brands.filter((_, i) => i !== index);
    setBrands(updatedBrands);
  };

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
          setLatitude(lat);
          setLongitude(lng);
          setMeetingData((prevData) => ({
            ...prevData,
            latitude: lat,
            longitude: lng,
          }));
        },
        (error) => {
          console.error("Geolocation error:", error);
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  }, []);

  useEffect(() => {
    api
      .get("/employee-profile")
      .then((res) => {
        const data = res.data.data;
        setUsername(data.username || "Unknown User");
        setMeetingData((prevData) => ({
          ...prevData,
          dealer: data.dealer,
          data: data.data,
        }));
      })
      .catch((err) => console.error("Employee fetch error:", err));
  }, []);

  useEffect(() => {
    api
      .get("/get/state")
      .then((res) => {
        if (res.data.success && Array.isArray(res.data.data)) {
          setStates(res.data.data);
        } else {
          console.error("Invalid state data:", res.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching states:", err);
      });
  }, []);

  useEffect(() => {
    api
      .get("/setting/get/key")
      .then((res) => {
        if (
          res.data.success &&
          Array.isArray(res.data.data) &&
          res.data.data.length > 0
        ) {
          // Just take the key_value from the first item in the data array
          const apiKeyValue = res.data.data[0].key_value;
          if (apiKeyValue) {
            setApiKey(apiKeyValue);
          } else {
            console.error("API key value not found in the response.");
          }
        } else {
          console.error("Invalid API key response or empty data:", res.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching API key:", err);
      });
  }, []);

  useEffect(() => {
  if (!latitude || !longitude || !apiKey) return;

  fetch(
    `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`
  )
    .then((res) => res.json())
    .then((data) => {
      console.log("Full Geocoding Response:", data);

      if (
        data.results &&
        data.results.length > 0 &&
        data.results[0].geometry &&
        data.results[0].geometry.location
      ) {
        const { lat, lng } = data.results[0].geometry.location;
        console.log("Refined Lat:", lat);
        console.log("Refined Lng:", lng);
        setLocation({ lat, lng }); // 👈 You should modify setLocation to accept an object
      } else {
        setLocation({ lat: null, lng: null });
      }
    })
    .catch((err) => {
      console.error("Location fetch error:", err);
      setLocation({ lat: null, lng: null });
    });
}, [latitude, longitude, apiKey]);


  const handleSaveMeeting = () => {
    if (latitude === null || longitude === null) {
      alert("Please allow location access to save the meeting.");
      return;
    }


    if (!dropdownValue) {
      alert("Please select a role before saving.");
      return;
    }

    if (dropdownValue === "Farmer") {
      if (!farmerName) {
        alert("Farmer Name is required.");
        return;
      }
      if (!dob) {
        alert("DOB is required.");
        return;
      }
      if (!phone) {
        alert("Phone number is required.");
        return;
      }
      if (!address) {
        alert("Address is required.");
        return;
      }
      if (!selectedState) {
        alert("Please select a State.");
        return;
      }
    }

    if (dropdownValue === "Dealer") {
      if (!dealerName) {
        alert("Dealer Name is required.");
        return;
      }
      if (!phone) {
        alert("Phone number is required.");
        return;
      }
      if (!selectedState) {
        alert("Please select a State.");
        return;
      }
    }

    const formData = new FormData();
    formData.append("dealer", dropdownValue);
    formData.append("role", dropdownValue);
    formData.append("data", textInput);
    formData.append("state", selectedState);
    formData.append("latitude", latitude);
    formData.append("longitude", longitude);


    if (imageFile) {
      formData.append("image", imageFile);
    }

    if (dropdownValue === "Farmer") {
      formData.append("farmer_name", farmerName);
      formData.append("dob", dob);
      formData.append("anniversay_date", anniversaryDate);
      formData.append("phone", phone);
      formData.append("address", address);
      formData.append("cattlerecord", record);
      formData.append("cattle_buff", cattleBuff);
      formData.append("cattle_cow", cattleCow);
      formData.append("cattle_calf", cattleCalf);
      formData.append("trail_bag", trailBag);
      formData.append("schedule", schedule);
      formData.append("meeting_note", meetingNote);
    } else {
      formData.append("dealer_name", dealerName);
      formData.append("firm_name", firmName);
      formData.append("phone", phone);
      formData.append("address", address);
      brands.forEach((b, i) => {
        formData.append(`brand[${i}]`, b);
      });

      formData.append("sale", sale);
      formData.append("meeting_note", meetingNote);
    }

    api
      .post("/addMeeting", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log("Meeting saved:", res.data);
        alert("Meeting saved successfully!");
        resetForm(); // ✅ Clear all fields

      })
      .catch((err) => {
        console.error("Error saving meeting:", err);
        alert("Failed to save meeting");
      });
  };

  const resetForm = () => {
    setDropdownValue("");
    setTextInput("");
    setLocation("");
    setUploadedImage(null);
    setImageFile(null);
    setDropdownOpen(false);
    setSelectedState("");

    // Dealer fields
    setDealerName("");
    setFirmName("");
    setBrands([""]);

    setSale("");

    // Farmer fields
    setFarmerName("");
    setDob("");
    setAnniversaryDate("");
    setPhone("");
    setAddress("");
    setRecord("");
    setCattleBuff("");
    setCattleCow("");
    setCattleCalf("");
    setTrailBag("");
    setSchedule("");
    setMeetingNote("");
    setBags("");
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) {
      alert("No image selected. Please upload an image.");
      return;
    }

    if (!file.type.startsWith("image/")) {
      alert("The selected file is not an image.");
      return;
    }

    setImageFile(file);
    const reader = new FileReader();
    reader.onloadend = () => {
      if (!reader.result) {
        alert("Failed to load image preview.");
      } else {
        setUploadedImage(reader.result);
      }
    };
    reader.onerror = () => {
      alert("Error reading the image file.");
    };
    reader.readAsDataURL(file);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const selectRole = (role) => {
    setDropdownValue(role);
    setDropdownOpen(false);
  };

  const handleViewMeeting = () => {
    api
      .get("/getMeeting")
      .then((res) => {
        const data = res.data.data;
        const today = new Date().toISOString().split("T")[0];

        const todayMeetings = Array.isArray(data)
          ? data.filter(
              (meeting) => meeting.date && meeting.date.startsWith(today)
            )
          : [];

        setMeetingsList(todayMeetings);
        setShowModal(true);
      })
      .catch((err) => {
        console.error("Error fetching meetings:", err);
        alert("Failed to fetch meetings");
      });
  };

  const closeModal = () => setShowModal(false);
  const closeZoomModal = () => setZoomImageUrl(null);

  return (
    <section className="meeting-section">
      <div className="container">
        <div className="inner-content">
          <div className="left-wrapper">
            <div className="top-bar">
              <div className="img-box">
                <img src="./images/p-1.png" alt="User profile" />
              </div>
              <div className="user-name">
                <h4>{username}</h4>
              </div>
            </div>

            <div className="bottom-bar">
              <div className="custom-dropdown">
                <div className="custom-select-box" onClick={toggleDropdown}>
                  {dropdownValue || "Select Role"}
                  <span className="arrow">{dropdownOpen ? "▲" : "▼"}</span>
                </div>
                {dropdownOpen && (
                  <ul className="custom-options">
                    {roles.map((role) => (
                      <li
                        key={role}
                        className={role === dropdownValue ? "selected" : ""}
                        onClick={() => selectRole(role)}
                      >
                        {role}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              {dropdownValue === "Farmer" && (
                <div className="farmer-form">
                  <div className="filed-wrap">
                    <label>Farmer Name</label>
                    <input
                      placeholder="Farmer Name"
                      value={farmerName}
                      onChange={(e) => setFarmerName(e.target.value)}
                    />
                  </div>

                  <div className="filed-wrap">
                    <label>Date of Birth</label>
                    <input
                      type="date"
                      placeholder="Date of Birth"
                      value={dob}
                      onChange={(e) => setDob(e.target.value)}
                    />
                  </div>

                  <div className="filed-wrap">
                    <label>Anniversary</label>
                    <input
                      type="date"
                      placeholder="Anniversary Date"
                      value={anniversaryDate}
                      onChange={(e) => setAnniversaryDate(e.target.value)}
                    />
                  </div>

                  <div className="filed-wrap">
                    <label>Phone</label>
                    <input
                      placeholder="Phone number"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                    />
                  </div>

                  <div className="filed-wrap">
                    <label>Address</label>
                    <input
                      placeholder="Address"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                    />
                  </div>

                  <div className="filed-wrap">
                    <label>State</label>
                    <select
                      value={selectedState}
                      onChange={(e) => setSelectedState(e.target.value)}
                    >
                      <option value="">-- Select State --</option>
                      {states.map((state) => (
                        <option key={state.state_id} value={state.state_title}>
                          {state.state_title}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="filed-wrap">
                    <label>Buffalo</label>
                    <input
                      placeholder="Total Buffalo"
                      value={cattleBuff}
                      onChange={(e) => setCattleBuff(e.target.value)}
                    />
                  </div>

                  <div className="filed-wrap">
                    <label>Cow</label>
                    <input
                      placeholder="Total Cow"
                      value={cattleCow}
                      onChange={(e) => setCattleCow(e.target.value)}
                    />
                  </div>

                  <div className="filed-wrap">
                    <label>Calf</label>
                    <input
                      placeholder="Total Calf"
                      value={cattleCalf}
                      onChange={(e) => setCattleCalf(e.target.value)}
                    />
                  </div>

                  <div className="filed-wrap">
                    <label>Trial (Bags)</label>
                    <input
                      placeholder="Trial (Bags)"
                      value={trailBag}
                      onChange={(e) => setTrailBag(e.target.value)}
                    />
                  </div>

                  <div className="filed-wrap">
                    <label>Next Meeting </label>
                    <input
                      type="date"
                      placeholder="Next Meeting"
                      value={schedule}
                      onChange={(e) => setSchedule(e.target.value)}
                    />
                  </div>

                  <div className="filed-wrap">
                    <label>Note</label>
                    <textarea
                      placeholder="Meeting Note"
                      value={meetingNote}
                      onChange={(e) => setMeetingNote(e.target.value)}
                    />
                  </div>
                </div>
              )}

              {dropdownValue !== "Farmer" && dropdownValue && (
                <div className="dealer-form">
                  <div className="filed-wrap">
                    <label>Dealer Name</label>
                    <input
                      placeholder="Dealer Name"
                      value={dealerName}
                      onChange={(e) => setDealerName(e.target.value)}
                    />
                  </div>

                  <div className="filed-wrap">
                    <label>Phone</label>
                    <input
                      placeholder="Phone number"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                    />
                  </div>

                  <div className="filed-wrap">
                    <label>Firm Name</label>
                    <input
                      placeholder="Firm Name"
                      value={firmName}
                      onChange={(e) => setFirmName(e.target.value)}
                    />
                  </div>

                  <div className="filed-wrap">
                    <label>State</label>
                    <select
                      value={selectedState}
                      onChange={(e) => setSelectedState(e.target.value)}
                    >
                      <option value="">-- Select State --</option>
                      {states.map((state) => (
                        <option key={state.state_id} value={state.state_title}>
                          {state.state_title}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="filed-wrap">
                    <label>Cattle Feed Brand</label>
                    {brands.map((b, index) => (
                      <div
                        key={index}
                        style={{
                          display: "grid",
                          alignItems: "center",
                          gridGap: "8px",
                          marginBottom: "8px",
                        }}
                      >
                        <input
                          placeholder={`Brand`}
                          value={b}
                          onChange={(e) =>
                            handleBrandChange(index, e.target.value)
                          }
                          style={{ flex: 1 }}
                        />
                        {brands.length > 1 && (
                          <button
                            type="button"
                            onClick={() => deleteBrandField(index)}
                            className="delete-brand-btn"
                            style={{
                              background: "#c60808",
                              color: "white",
                              border: "none",
                              padding: "4px 8px",
                              cursor: "pointer",
                            }}
                          >
                            ✕
                          </button>
                        )}
                      </div>
                    ))}
                    {brands.length < 4 && (
                      <button
                        type="button"
                        onClick={addBrandField}
                        className="add-brand-btn"
                      >
                        + Add Brand
                      </button>
                    )}
                  </div>

                  <div className="filed-wrap">
                    <label>Sale (bags) </label>
                    <input
                      placeholder="Total Sale (bags)"
                      value={sale}
                      onChange={(e) => setSale(e.target.value)}
                    />
                  </div>

                  <div className="filed-wrap">
                    <label>Note</label>
                    <textarea
                      placeholder="Meeting Note"
                      value={meetingNote}
                      onChange={(e) => setMeetingNote(e.target.value)}
                    />
                  </div>
                   <div className="filed-wrap">
                    <label>Address</label>
                    <input
                      placeholder="Address"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                    />
                  </div>
                </div>
              )}

              <div className="upload-image">
                <h3>Upload Image</h3>
                <label className="upload-label">
                  <img src="./images/icon-image.png" />
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleImageUpload}
                  />
                </label>
                {uploadedImage && (
                  <div className="image-preview">
                    <img src={uploadedImage} alt="Uploaded Preview" />
                  </div>
                )}
              </div>

             

              <button
                onClick={handleSaveMeeting}
              >
                Save Meeting
              </button>

              <button className="view-btn-001" onClick={handleViewMeeting}>
                View Meeting
              </button>
            </div>
          </div>

          <div className="right-wrapper">
            <img src="./images/m-1.jpg" alt="Meeting visual" />
          </div>
        </div>

        {showModal && (
          <div className="modal-overlay">
            <div className="modal-content">
              <div className="top-wrap-001">
                <h2>Meetings</h2>
                <button className="close-btn" onClick={closeModal}>
                  <i className="fa-solid fa-xmark"></i>
                </button>
              </div>
              <div className="bottom-wrap-001">
                <div className="table-wrapper">
                  <table className="employee-table">
                    <thead>
                      <tr>
                        <th>Role</th>
                        <th>Date</th>

                        <th>Image</th>
                      </tr>
                    </thead>
                    <tbody>
                      {meetingsList.map((meeting, index) => (
                        <tr key={index}>
                          <td>{meeting.dealer}</td>
                          <td>{meeting.date}</td>

                          <td>
                            {meeting.image ? (
                              <img
                                src={meeting.image}
                                alt="Meeting"
                                style={{
                                  width: "50px",
                                  height: "50px",
                                  cursor: "pointer",
                                }}
                                onClick={() => setZoomImageUrl(meeting.image)}
                              />
                            ) : (
                              "No Image"
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}

        {zoomImageUrl && (
          <div className="zoom-modal-overlay" onClick={closeZoomModal}>
            <div
              className="zoom-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <button className="close-btn" onClick={closeZoomModal}>
                <i className="fa-solid fa-xmark"></i>
              </button>
              <img src={zoomImageUrl} alt="Zoomed" className="zoomed-image" />
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Meeting;
